<form *ngIf="!!creditCardForm" [formGroup]="creditCardForm">
  <div class="ss-credit">
    <div class="w-100">
      <div class="margin-bottom">
        <ucx-credit-card-number
          [creditCardNumberform]="creditCardForm"
          [semafoneConfig]="creditCardInfo?.semafoneConfig"
          [creditCardNumberFormData]="creditCarNumberFormData"
        ></ucx-credit-card-number>
      </div>
      <ds-form-field class="margin-bottom">
        <ds-input-label>{{
          creditCardInfo?.creditCardFormData?.ccDateInputlabel
        }}</ds-input-label>
        <input
          dsInput
          [dsMask]="inputMasktype.CreditCardExpiry"
          [placeholder]="creditCardInfo?.creditCardFormData?.ccDatePlaceholder"
          [value]="expiryDateControl?.value"
          [formControl]="expiryDateControl"
          (blur)="validateDate()"
          id="expiryDate"
        />
        <ds-error
          [errorMessage]="
            creditCardInfo?.creditCardFormData?.ccDateErrorMessage
          "
          *ngIf="showExpiryDateError"
        ></ds-error>
      </ds-form-field>
      <ds-form-field>
        <ds-input-label>{{
          creditCardInfo?.creditCardFormData?.ccCVVInputlabel
        }}</ds-input-label>
        <input
          type="text"
          dsInput
          [dsMask]="inputMasktype.CVV"
          [placeholder]="creditCardInfo?.creditCardFormData?.ccCVVPlaceholder"
          autocomplete="off"
          [formControl]="cvvControl"
          (blur)="validateSecurityCode()"
        />
        <ds-popover
          dsSuffix
          [triggerLabel]="
            creditCardInfo?.creditCardFormData?.popoverTriggerLabel
          "
          [closeLabel]="creditCardInfo?.creditCardFormData?.popoverCloseLabel"
          [content]="creditCardInfo?.creditCardFormData?.popoverContent"
          [zIndex]="3000"
        ></ds-popover>
        <ds-error
          [errorMessage]="creditCardInfo?.creditCardFormData?.ccCVVErrorMessage"
          *ngIf="showCvvError"
        ></ds-error>
      </ds-form-field>
    </div>
  </div>
</form>
